import LOGO_EDOMEX from "./../../../assets/images/escudos/ESCUDO EDOMEX_Horizontal_FondoOscuro.png";
import LOGO_CONALEPEDOMEX from "./../../../assets/images/escudos/conalepBlanco.png";
import INTELIGENCIA_ARTIFICIAL from "./../../../assets/images/egresados/anuncios/cp_inteligencia_aa.png";

const InformacionParaEgresados = [
    {
        id: 1,
        title: "Gobierno del Estado de México",
        description: "Consulta información oficial, programas y servicios del Gobierno del Estado de México.",
        src: LOGO_EDOMEX,
        link: "https://edomex.gob.mx/", 
    },
    {
        id: 2,
        title: "CONALEP Estado de México",
        description: "Visita el portal oficial del CONALEP Estado de México. Accede a información, programas y servicios del CONALEP.",
        src: LOGO_CONALEPEDOMEX,
        link: "https://www.conalepmex.edu.mx/" 
    },
    {
        id: 3,
        title: "Secretaría del Trabajo del Edoméx",
        description: "Accede a programas de empleo, capacitaciones y oportunidades laborales en el Estado de México.",
        src: "https://mexicoteemplea.gob.mx/assets/images/logo-trabajo2.png",
        link: "https://strabajo.edomex.gob.mx/", 
    },
    {
        id: 4,
        title: "Encuesta para Egresados CONALEP",
        description: "Ayúdanos a mejorar respondiendo nuestra encuesta dirigida a nuestros egresados.",
        src: "https://insr.conalepmex.edu.mx/inscripcion/assets/login/img/img-fondo.png",
        link: "https://insr.conalepmex.edu.mx/inscripcion/login"
    },
    {
        id: 5,
        title: "Feria de Empleo para Mujeres 2025",
        description: "Acércate, conoce las vacantes disponibles y encuentra la oportunidad que estás buscando.",
        src: "https://scontent.fmex31-1.fna.fbcdn.net/v/t39.30808-6/569237944_1132650919049874_7748497621543768589_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=833d8c&_nc_ohc=iKFsVXfgYgwQ7kNvwHETgfN&_nc_oc=AdngNa6OiUjQg5QO3axQ3g59diQ8iUbUqo_EXguXSg_x6aQeu62FuBRVcYC3PD6YMLQ&_nc_zt=23&_nc_ht=scontent.fmex31-1.fna&_nc_gid=WBaohnSbT00hV5_WJL9XfA&oh=00_AfjRz43d3pIROsflFelG0BIx8gxk_4yXg2gO4RznTKZNAA&oe=6913E841",
        link: "https://empleo.toluca.gob.mx/",
        linkText: "Regístrate"

    },
    {
        id:6,
        title: "Centro Público de Formación en Inteligencia Artificial",
        description: "Impulsa tu carrera con programas especializados y diseñados para el futuro digital de México",
        src: INTELIGENCIA_ARTIFICIAL,
        link: "https://www.labmexia.gob.mx/#inicio",
        linkText: "Regístrate"
    }
];
export default InformacionParaEgresados;
